import React from 'react';
import classNames from 'classnames';
/**
 * Bronson ContextNotification component.
 *
 * @see https://bronson.vwfs.tools/default/components/detail/bronson-context-notification.html
 *
 * @constructor
 */
export function ContextNotification({ children, testId, ...otherProps }) {
    const divClassName = classNames('js-context-notification' // Used in Bronson CSS.
    ).trim();
    return (React.createElement("div", { className: divClassName, "data-testid": testId, ...otherProps }, React.Children.map(children, (child) => React.cloneElement(child, { context: true }))));
}
